.timesheets_header {
  margin-bottom: 4rem;
}

.cardStyles {
  background-color: #dcdcdc;
  padding: 20px 20px 0;
  border: 4px solid white;
  border-top: none;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
}
.cardStylesBottom {
  background-color: #dcdcdc;
  padding: 20px 20px 0;
  border: 4px solid white;
  border-bottom: none;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
}

.cardText {
  font-size: 36px;
  display: flex;
  margin-right: 6px;
}

.dateText {
  font-size: 29px;
  display: flex;
  margin-right: 6px;
}

.cardStylesMiddle {
  background-color: #f5f5f5;
  padding: 20px 20px 0;
  border: 4px solid white;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
}
.cardStylesHoliday {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
}

.btn_arrow {
  transition: all 0.3s ease 0s;
  &.active {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

.holidayBtnClicked {
  background-color: #0e6cb9;
  border-color: #095da1;
}

.holidayFormBackground {
  background-color: #ffffff;
}

.alert {
  position: relative;
  border-radius: 0.25rem;
  transition: all 1s ease 0s;
  overflow: hidden;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  height: auto;
}

.alertSuccess {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.alertError {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.activeAlert {
  opacity: 1;
  height: auto;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
}

input::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.inputError {
  border-color: red!important;
}
.inputErrorMessage {
  color: red;
  font-size: 13px;
}

@media (max-width: 768px) {
  .submitBtn {
    display: block;
    width: 100%;
  }
}


